export const Star = ({ size = 24, className = "", spin = false }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    className={`${spin ? "star-spin" : ""} ${className}`}
    aria-hidden="true"
  >
    <path d="M12 0 L14.4 8.4 L23 9.6 L16.5 15 L18.8 24 L12 19.2 L5.2 24 L7.5 15 L1 9.6 L9.6 8.4 Z" />
  </svg>
);
